import tr from './tr.json';
import en from './en.json';

/** i18next namespace this theme owns. */
export const NS = 'theme-sorsy';

/**
 * Chrome copy for the `theme-sorsy` theme — labels the theme renders
 * itself (the enquiry CTA's headline, phone-link caption, note), NOT
 * authored page content. A page author's own title/subtitle props on
 * `KitEnquiryCta` still win — these are only the defaults when they leave
 * a field blank, same split `theme-akademi-net` and the generic
 * `site-builder-blocks` catalogue use.
 */
export const locales = [{ ns: NS, resources: { tr, en } }];
